import { createContext, ReactElement, ReactNode, useContext } from 'react';

const InvertedContext = createContext<{ inverted: boolean }>({
  inverted: false,
});

export const InvertedProvider = ({
  inverted,
  children,
}: {
  inverted: boolean;
  children: ReactNode;
}): ReactElement => (
  <InvertedContext.Provider value={{ inverted }}>
    {children}
  </InvertedContext.Provider>
);

export const useInverted = (): { inverted: boolean } =>
  useContext(InvertedContext);
